import React from 'react'
import { useTrans } from 'hooks'
import { ListingHead, Page, StoreLocator, StoreLocatorGeoList } from 'components/organisms'
import styles from './StoreLocatorTemplate.module.sass'
import { ProvinciaNode, RegioneNode, RivenditoreStoreLocatorNode } from '@gql/graphql-get'
import { JsonLd } from '@components/atoms'

interface Props {
  pagina?: any
  regioni?: RegioneNode[]
  rivenditori?: RivenditoreStoreLocatorNode[]
  rivenditoriFiltered?: RivenditoreStoreLocatorNode[]
  province?: ProvinciaNode[]
}

const StoreLocatorTemplate = (props: Props) => {
  const {
    pagina = {},
    regioni = [],
    rivenditori = [],
    province = [],
    rivenditoriFiltered = [],
  } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <ListingHead pagina={pagina} />
      <main className={styles.layout}>
        <StoreLocator
          item={{
            name: t('Trova il rivenditore più vicino a te'),
          }}
          rivenditori={rivenditori}
          rivenditoriFiltered={rivenditoriFiltered}
        />
        <StoreLocatorGeoList
          title={
            province && province.length > 0 ? t('Ricerca per provincia') : t('Ricerca per regione')
          }
          items={province && province.length > 0 ? province : regioni}
        />
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default StoreLocatorTemplate
